export enum DashDonationType {    
    Kidney = 0,
    Liver = 1
}